import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2fb85fdc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb85fdc')) {
      api.createRecord('2fb85fdc', component.options)
    } else {
      api.reload('2fb85fdc', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=2fb85fdc", function () {
      api.rerender('2fb85fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/views/App.vue"
export default component.exports